<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-row class="align-items-center">
          <b-col>
            <h3 class="m-0">Gerenciamento de Pacientes</h3>
          </b-col>
          <b-col class="text-right">
            <b-button variant="secondary" v-b-modal.mdlFiltros class="mr-2">
              Filtros
            </b-button>
            <b-button variant="primary" @click="novoPaciente"> Novo </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <b-table
          :items="pacientes"
          :fields="fields"
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          show-empty
          responsive
        >
          <template #empty>
            <div class="text-center">Nenhum registro encontrado.</div>
          </template>

          <template v-slot:cell(endereco)="data">
            {{
              `${data.item.endereco ?? ""}, ${
                data.item.numero_endereco ?? ""
              }, ${data.item.complemento ?? ""}
                ${data.item.bairro ?? ""}, ${data.item.cidade?.nome ?? ""} - ${
                data.item.estado?.nome ?? ""
              }`
            }}
          </template>

          <template v-slot:cell(acao)="data">
            <b-dropdown
              variant="clean"
              size="small"
              toggle-class="btn-icon"
              no-caret
            >
              <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
              </template>

              <b-dropdown-item @click="editarPaciente(data.item)"
                >Editar</b-dropdown-item
              >
            </b-dropdown>
          </template>
        </b-table>
      </b-card-body>

      <b-card-footer>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="m-0"
          ></b-pagination>

          <div class="d-flex align-items-center flex-wrap">
            <b-select v-model="perPage" size="sm" class="mr-4 per-page">
              <option
                v-for="option in [20, 50, 100]"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>

            <span>
              Exibindo de {{ fromPage }} até {{ toPage }} de
              {{ totalRows }} registros.
            </span>
          </div>
        </div>
      </b-card-footer>
    </b-card>

    <b-modal
      id="mdlFiltros"
      ref="mdlFiltros"
      title="Filtros"
      ok-title="Filtrar"
      @ok="getPacientes"
      @shown="validacao"
      cancel-title="Cancelar"
    >
      <b-form-group label="Nome do paciente:">
        <b-form-input v-model="filtros.nomePaciente" size="sm"></b-form-input>
      </b-form-group>

      <b-row>
        <b-col cols="6">
          <b-form-group label="CPF:">
            <b-form-input
              v-model="filtros.cpf"
              size="sm"
              data-inputmask="'alias': 'cpf'"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Cartão do SUS:">
            <b-form-input
              v-model="filtros.cartaoSUS"
              size="sm"
              data-inputmask="'alias': 'cartao_sus'"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Data de cadastro:">
        <b-row>
          <b-col cols="6">
            <b-form-datepicker
              v-model="filtros.dataCadastroInicio"
              size="sm"
            ></b-form-datepicker>
          </b-col>

          <b-col cols="6">
            <b-form-datepicker
              v-model="filtros.dataCadastroFim"
              size="sm"
            ></b-form-datepicker>
          </b-col>
        </b-row>
      </b-form-group>
    </b-modal>

    <paciente-formulario
      ref="mdlPacienteFormulario"
      @atualizar="getPacientes"
    ></paciente-formulario>
  </div>
</template>

<script>
import PacienteService from "@/core/services/paciente.service";
import PacienteFormulario from "./PacienteFormulario.vue";
import moment from "@/core/plugins/moment";
import Swal from "sweetalert2";
import Inputmask from "@/core/plugins/inputmask";

export default {
  name: "paciente-listar",

  components: {
    PacienteFormulario,
  },

  data() {
    return {
      pacientes: [],
      loading: false,
      fields: [
        {
          key: "data_cadastro",
          label: "Data",
          class: "text-center align-middle",
          sortable: true,
          formatter: "dataHoraFormatter",
        },
        {
          key: "cpf",
          label: "CPF",
          sortable: true,
          class: "align-center align-middle",
        },
        {
          key: "nome",
          label: "Nome",
          sortable: true,
          class: "align-middle",
        },
        {
          key: "endereco",
          label: "Endereço",
          sortable: true,
          class: "align-middle",
        },
        { key: "acao", label: "Ação", class: "text-center align-middle" },
      ],
      totalRows: 0,
      toPage: 0,
      fromPage: 0,
      currentPage: 1,
      perPage: 20,
      sortBy: "nome",
      sortDesc: false,
      filtros: {
        nomePaciente: null,
        cpf: null,
        cartaoSUS: null,
        dataCadastroInicio: null,
        dataCadastroFim: null,
      },
    };
  },

  mounted() {
    this.getPacientes();
  },

  methods: {
    getPacientes() {
      this.loading = true;

      PacienteService.getPacientes({
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        ...Object.flatten(Object.filter(this.filtros), "filtros"),
      })
        .then(({ data }) => {
          this.pacientes = data.data;
          this.totalRows = data.total;
          this.toPage = data.to;
          this.fromPage = data.from;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    novoPaciente() {
      this.$refs.mdlPacienteFormulario.exibirModal();
    },

    editarPaciente(paciente) {
      this.$refs.mdlPacienteFormulario.exibirModal(paciente);
    },

    async excluir(id) {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente excluir este paciente?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await PacienteService.excluir(id).then(() => {
            Swal.fire(
              "Sucesso!",
              "Atendimento excluído com sucesso.",
              "success"
            );
            this.getPacientes();
          });
        }
      });
    },

    dataFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },

    dataHoraFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "";
    },

    showOverlay() {
      this.$store.dispatch("toggleOverlay", {
        value: true,
        message: "Processando, aguarde...",
      });
    },

    hideOverlay() {
      this.$store.dispatch("toggleOverlay", { value: false });
    },

    validacao() {
      this.$nextTick(() => {
        Inputmask().mask(document.querySelectorAll("[data-inputmask]"));
      });
    },
  },

  watch: {
    currentPage() {
      this.getPacientes();
    },

    perPage() {
      this.getPacientes();
    },

    sortBy() {
      this.getPacientes();
    },

    sortDesc() {
      this.getPacientes();
    },
  },
};
</script>

<style scoped>
.per-page {
  height: calc(1.244em + 1.1rem + 2px) !important;
  width: 70px !important;
}
</style>
